import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Tag } from '@bringg/react-components';
import { TenderNotifyStatus as TenderNotifyStatusEnum } from '@bringg/types';

import styles from './tender-notify-status.module.scss';

interface Props {
	status: TenderNotifyStatusEnum;
}

const TenderNotifyStatus = ({ status }: Props) => {
	const { t } = useTranslation();

	return (
		<div className={styles.statusWrapper}>
			<span className={styles.statusTitle}>{t('TENDER_NOTIFY.STATUS.TITLE', 'Tender/Notify Status')}</span>
			<Tag className={styles.status}>{t(`TENDER_NOTIFY.STATUS.${status.toUpperCase()}`, status)}</Tag>
		</div>
	);
};

export default observer(TenderNotifyStatus);
